(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["set-product"] && !Shopify.designMode) return;
  try {
    
(function() {
$('.set-products .product-card-top').css('visible','visible')
$('.set-products .product-card-top').css({'visibility':'visible','opacity':1});
const setProducts = document.querySelectorAll('.set-products');
setProducts.forEach((container) => {
initiateScroll(container.querySelectorAll('.set-products__nav--btn'), container.querySelector('.grid-layout'));
});
})();

  } catch(e) { console.error(e); }
})();
})();
